web = window.web = window.web || {};
web.credits = window.web.credits = window.web.credits || {};
web.creditsSectionContent = window.web.creditsSectionContent = window.web.creditsSectionContent || {};

var $ = require('jquery');

web.creditsSectionContentSectionCotent = module.exports = function($context, options) {
    var t = this;
    t.instanceState = 'constructed';

    t.defaults = {};

    t.options = $.extend({}, t.defaults, options);

    t.$context = $context;

    t.SHOW_CLASS = null;

    t.actualVisiblity = false;
};

web.creditsSectionContentSectionCotent.prototype = {
    init: function(){
        var t = this;
        t._bindEvents();
    },

    setContext: function($context) {
        var t = this;

        t.$context = $context;
    },

    setShowClass: function(showClass){
        var t = this;

        t.SHOW_CLASS = showClass;
    },

    _bindEvents: function() {
        var t = this;

    },

    setVisibility: function(visiblity) {
        var t = this;
        t.actualVisiblity = visiblity;


        var eventName = "iAmHiddenNow";
        if (visiblity) {
            eventName = "iAmShownNow";
        }

        $(t).trigger({
            type: eventName,
            iAm: t,
            myId: t.getId()
        })

    },

    getActualVisibility: function(){
        var t = this;

        return t.actualVisiblity;
    },

    isVisible: function(){
        var t = this;

        return t.getActualVisibility();
    },

    redraw: function(){
        var t = this;

        if (t.isVisible())  {
            t.$context.addClass(t.SHOW_CLASS);
        } else {
            t.$context.removeClass(t.SHOW_CLASS);
        }
    },

    getId: function(){
        var t = this;

        return t.$context.data("sectionId");
    }
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/credits/sectionContent/SectionContent.js